import styled from '@emotion/styled';
import React, { useRef } from 'react';
import { mediaQuery } from '@styles/index';
import useOnScreen from './hooks/useOnScreen';

const Container = styled.div`
  width: 100%;
  height: 396px;
  ${mediaQuery.uptoMobile} {
    height: 624px;
  }
`;
const createLoadableVisibilityComponent = ({ Component, name }) => {
  const LoadOnVisibleInView = (props) => {
    const ref = useRef(null);
    const isVisible = useOnScreen({ ref, name });
    return (
      <Container ref={ref} id={name}>
        {isVisible && <Component {...props} />}
      </Container>
    );
  };
  return LoadOnVisibleInView;
};

export default createLoadableVisibilityComponent;
